import { useQuery } from '@tanstack/react-query';
import { getLeadOptions } from '../../lib/api/options';
import type { GetLeadOptionsParams } from '../../lib/api/options';

export function useLeadOptions(params: GetLeadOptionsParams = {}, enabled = true) {
  return useQuery({
    queryKey: ['options', 'leads', JSON.stringify(params)],
    queryFn: () => getLeadOptions(params),
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}
